var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommercial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6199 8.89713V18H1.48821L1.45837 8.95223C2.7191 9.19835 3.78213 8.75754 4.53931 7.78774C5.25546 8.62162 6.22152 9.18366 7.32186 9.17999C8.42219 9.17631 9.36214 8.64366 10.0858 7.72162C10.7944 8.51509 11.63 9.05141 12.6557 9.07346C13.6814 9.0955 14.6363 8.58488 15.345 7.72897C16.1842 8.74652 17.3442 9.23509 18.6199 8.9008V8.89713ZM9.27635 10.1314H4.50201V17.4012H9.27635V10.1314ZM15.7441 14.1539L15.7254 10.1277L11.6225 10.1388L11.6411 14.1649L15.7441 14.1539Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74641 5.68652L5.29285 5.67917L6.35588 0.0330505L9.74641 0.036724V5.68652Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56546 5.67183H0.268555L2.14472 0.653869C2.27154 0.31591 2.6781 0.0403997 3.03245 0.0440732L5.62476 0.0697875L4.56919 5.67183H4.56546Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6848 5.67918L10.4551 5.68653V0.0293878L13.6591 0L14.6848 5.67918Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4152 0.690601L19.7464 5.6755L15.4234 5.69019L14.3865 0.011009L16.5685 0.00366211C16.8781 0.00366211 17.266 0.367336 17.4152 0.686927V0.690601Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33605 7.65919C8.02684 8.87878 6.13948 8.75388 5.02795 7.38L5.16969 6.34409H9.65309C9.90673 6.76653 9.72023 7.29919 9.33605 7.65919Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9571 7.26245C13.8643 8.65102 12.0403 8.76123 10.802 7.59307C10.4775 7.28817 10.3283 6.81796 10.5297 6.35143L14.7706 6.34409L14.9571 7.26245Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.34775C19.9403 7.22938 19.2428 7.94571 18.5603 8.22856C17.6539 8.60326 16.7736 8.29101 16.0798 7.68856C15.6919 7.3506 15.5353 6.86571 15.6061 6.35142H20V6.34775Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46102 6.34039C4.46848 7.43509 3.41664 8.29468 2.35733 8.33876C1.18239 8.38652 0.145468 7.54529 0 6.34407H4.46102V6.34039Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercial);
export default __webpack_public_path__ + "static/media/commercial.ca92ee5084ca248add3531296aa544a8.svg";
export { ForwardRef as ReactComponent };